import { CalendarClock, Trash2, XCircle } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { cn } from '@/utils/cn'

export function FooterActions({
  canDelete,
  isClosed,
  canScheduleFuture,
  primaryLabel,
  primaryIcon,
  primaryClassName,
  primaryDisabled,
  primaryLoading,
  onDelete,
  onLoss,
  onFuture,
  onPrimary,
}: {
  canDelete: boolean
  isClosed: boolean
  canScheduleFuture: boolean
  primaryLabel?: string
  primaryIcon?: React.ReactNode
  primaryClassName?: string
  primaryDisabled?: boolean
  primaryLoading?: boolean
  onDelete: () => void
  onLoss: () => void
  onFuture: () => void
  onPrimary?: () => void
}) {
  const hasSecondary = canDelete || !isClosed || canScheduleFuture
  const hasPrimary = Boolean(primaryLabel && onPrimary)

  return (
    <footer className="shrink-0 border-t border-white/[0.06] bg-bg-card/95 p-3 backdrop-blur-md">
      <div className="flex items-center gap-2 overflow-x-auto">
        {hasSecondary && (
          <div className="flex shrink-0 items-center gap-2">
            {!isClosed && (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                icon={<XCircle size={13} />}
                onClick={onLoss}
                className="shrink-0 whitespace-nowrap bg-red-600 text-white hover:bg-red-700 hover:text-white"
              >
                Perdido
              </Button>
            )}

            {canScheduleFuture && (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                icon={<CalendarClock size={13} />}
                onClick={onFuture}
                className="shrink-0 whitespace-nowrap bg-violet-600 text-white hover:bg-violet-700 hover:text-white"
              >
                Futuro
              </Button>
            )}

            {canDelete && (
              <Button
                type="button"
                variant="destructive"
                size="sm"
                icon={<Trash2 size={13} />}
                onClick={onDelete}
                className="shrink-0 whitespace-nowrap"
              >
                Excluir
              </Button>
            )}
          </div>
        )}

        {hasPrimary && (
          <Button
            type="button"
            variant="primary"
            size="sm"
            icon={primaryIcon}
            onClick={onPrimary}
            disabled={primaryDisabled}
            loading={primaryLoading}
            className={cn('ml-auto shrink-0 whitespace-nowrap', primaryClassName)}
          >
            {primaryLabel}
          </Button>
        )}
      </div>
    </footer>
  )
}
